
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  SET_ACTIVITY_TYPES: (state, payload) => state.activityTypes = payload,
}